module.exports = "/images/sl.svg?4d84691d2d1b79310d7e8ea61d3f6da0";